import { useEffect } from 'react';

function useFixedBody(condition: boolean) {
  useEffect(() => {
    // If the condition is falsy then we need to make the body scrollable.
    if (!condition) {
      document.body.classList.remove('overflow-hidden');
    } else {
      document.body.classList.add('overflow-hidden');
    }

    return () => document.body.classList.remove('overflow-hidden');
  }, [condition]);
}

export default useFixedBody;
